import { TextEditor } from "./TextEditor";
import { TextEditorDialog } from "./TextEditorDialog";

export default TextEditorDialog;
export { TextEditor, TextEditorDialog };
